<template>
<div class="action-item-modal">
    <action-item :item="item" mode="modal"></action-item>
</div>
</template>
<script>

export default {
    props: ["item"],
    inject: ['closeModal'],
    components: { 
        ActionItem: () => import("./ActionItem.vue")
     },
    data() {
        return {
        }
    },
    computed: {
        ...amfx.map("actionItems", "items"),
        title() { return "Action Item" },
        buttons() { return "Close" },
    },
    methods: {
    },
    watch: {
        items() {
            this.closeModal();
        }
    }
}

</script>

<style lang="scss" scoped>

    .action-item.expanded {
        border: 1px solid darkgray !important;
        box-shadow: none;
        -webkit-box-shadow: none;
    }

</style>


// WEBPACK FOOTER //
// src/action-items/ActionItemModal.vue